"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _UISortTH = _interopRequireDefault(require("UIComponents/table/UISortTH"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _HubPickerRow = _interopRequireDefault(require("./HubPickerRow"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _RequestStatusTypes = _interopRequireDefault(require("hub-pickers-lib/constants/RequestStatusTypes"));

var _AnalyticsPeriod = _interopRequireDefault(require("hub-pickers-lib/constants/AnalyticsPeriod"));

var _links = _interopRequireWildcard(require("../utils/links"));

var _AccountFetcher = require("../Accounts/AccountFetcher");

var _sorts = require("hub-pickers-lib/utils/sorts");

var _propTypes = _interopRequireDefault(require("prop-types"));

var HubPicker = (0, _createReactClass.default)({
  displayName: "HubPicker",
  propTypes: {
    redirectTo: _links.redirectLink,
    query: _propTypes.default.object,
    filter: _propTypes.default.string,
    analyticsPeriod: _propTypes.default.string,
    shouldGetAnalytics: _propTypes.default.bool,
    shouldWarnAboutObscured: _propTypes.default.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      redirectTo: _links.default.homeService,
      query: {},
      filter: '',
      sessionsPeriod: _AnalyticsPeriod.default.WEEKLY,
      shouldGetSessions: false,
      shouldWarnAboutObscured: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      accounts: (0, _immutable.List)(),
      accountsRequestStatus: _RequestStatusTypes.default.UNINITIALIZED,
      pinnedAccounts: (0, _immutable.List)(),
      analytics: (0, _immutable.Map)(),
      analyticsRequestStatus: _RequestStatusTypes.default.UNINITIALIZED,
      sortField: '',
      sortDir: '',
      hubsFailedToLoad: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this = this;

    var promises = [(0, _AccountFetcher.getAccounts)(true, false)];

    if (this.props.shouldGetAnalytics) {
      promises.push((0, _AccountFetcher.getAnalytics)(this.props.analyticsPeriod));
    }

    Promise.all(promises).then(function (values) {
      _this.setState(Object.assign({}, values[0], {}, values[1]));
    });
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.props.analyticsPeriod !== nextProps.analyticsPeriod) {
      this.setState({
        analyticsRequestStatus: _RequestStatusTypes.default.PENDING
      }, function () {
        (0, _AccountFetcher.getAnalytics)(nextProps.analyticsPeriod).then(function (payload) {
          _this2.setState(payload);
        });
      });
    }
  },
  getFilteredAccounts: function getFilteredAccounts() {
    if (!this.props.filter) {
      return this.state.accounts;
    }

    var filter = this.props.filter.toLowerCase();
    return this.state.accounts.filter(function (account) {
      return account.accountName.toLowerCase().includes(filter) || account.domain.toLowerCase().includes(filter) || account.id.toString().includes(filter);
    });
  },
  onSortChange: function onSortChange(field) {
    var _this3 = this;

    return function (event) {
      var sortedAccounts = _this3.state.accounts.sort((0, _sorts.sortByField)(field, event.target.value));

      _this3.setState({
        sortDir: event.target.value,
        sortField: field,
        accounts: sortedAccounts
      });
    };
  },
  onNumericalSortChange: function onNumericalSortChange(field) {
    var _this4 = this;

    return function (event) {
      var sortedAccounts = _this4.state.accounts.sort((0, _sorts.sortByNumericalField)(field, event.target.value));

      _this4.setState({
        sortDir: event.target.value,
        sortField: field,
        accounts: sortedAccounts
      });
    };
  },
  onAnalyticsSortChange: function onAnalyticsSortChange(property) {
    var _this5 = this;

    return function (event) {
      var sortedAccounts = _this5.state.accounts.sort((0, _sorts.sortByAnalytics)(_this5.state.analytics, property, event.target.value));

      _this5.setState({
        sortDir: event.target.value,
        sortField: property,
        accounts: sortedAccounts
      });
    };
  },
  onPinChange: function onPinChange(accountId) {
    var _this6 = this;

    var pinnedAccounts = this.state.pinnedAccounts;
    var updatedPinnedAccounts;

    if (pinnedAccounts.includes(accountId)) {
      var index = pinnedAccounts.indexOf(accountId);
      updatedPinnedAccounts = pinnedAccounts.delete(index);
    } else {
      updatedPinnedAccounts = pinnedAccounts.push(accountId);
    }

    (0, _AccountFetcher.setPinnedAccounts)(updatedPinnedAccounts).then(function (resp) {
      _this6.setState({
        pinnedAccounts: resp
      });
    });
  },
  renderLoader: function renderLoader() {
    return _react.default.createElement("tr", null, _react.default.createElement("td", {
      colSpan: this.props.shouldGetAnalytics ? 5 : 3
    }, _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 50
    })));
  },
  renderTableContents: function renderTableContents() {
    var _this7 = this;

    var filteredAccounts = this.getFilteredAccounts();
    var shouldGetAnalytics = this.props.shouldGetAnalytics;

    if (filteredAccounts.size === 0) {
      return _react.default.createElement("tr", {
        className: "empty-accounts-table"
      }, _react.default.createElement("td", {
        colSpan: shouldGetAnalytics ? 5 : 3
      }, _I18n.default.text('hubPicker.noFilteredResults')));
    }

    var _this$state = this.state,
        analytics = _this$state.analytics,
        analyticsRequestStatus = _this$state.analyticsRequestStatus;
    var unpinnedAccounts = filteredAccounts.filter(function (account) {
      return !_this7.state.pinnedAccounts.contains(account.id);
    });
    var pinnedAccountRows = this.state.pinnedAccounts.map(function (accountId, key) {
      var account = filteredAccounts.find(function (filteredAccount) {
        return filteredAccount.id === accountId;
      });

      if (!account) {
        return null;
      }

      return _react.default.createElement(_HubPickerRow.default, {
        key: key,
        account: account,
        pinned: true,
        onPinChange: _this7.onPinChange,
        shouldGetAnalytics: shouldGetAnalytics,
        analytics: analytics.get(account.id.toString()),
        analyticsRequestStatus: analyticsRequestStatus,
        query: _this7.props.query,
        redirectTo: _this7.props.redirectTo
      });
    });
    var unpinnedAccountRows = unpinnedAccounts.map(function (account, key) {
      return _react.default.createElement(_HubPickerRow.default, {
        key: key,
        account: account,
        pinned: false,
        onPinChange: _this7.onPinChange,
        shouldGetAnalytics: shouldGetAnalytics,
        analytics: analytics.get(account.id.toString()),
        analyticsRequestStatus: analyticsRequestStatus,
        query: _this7.props.query,
        redirectTo: _this7.props.redirectTo
      });
    });
    return [pinnedAccountRows, unpinnedAccountRows];
  },
  renderObscuredWarning: function renderObscuredWarning() {
    var accounts = this.state.accounts;

    if (accounts.find(function (account) {
      return account.get('obscured');
    }) === undefined) {
      return null;
    }

    return _react.default.createElement(_UIAlert.default, {
      className: "m-bottom-4",
      titleText: _I18n.default.text('hubPicker.obscuredAccounts.title'),
      type: "info"
    }, _I18n.default.text('hubPicker.obscuredAccounts.description'));
  },
  renderHubsFailedToLoadWarningBanner: function renderHubsFailedToLoadWarningBanner() {
    return _react.default.createElement(_UIAlert.default, {
      className: "m-bottom-4",
      titleText: _I18n.default.text('hubPicker.hubsFailedToLoad'),
      type: "warning"
    });
  },
  render: function render() {
    var _this$state2 = this.state,
        accounts = _this$state2.accounts,
        accountsRequestStatus = _this$state2.accountsRequestStatus,
        analyticsRequestStatus = _this$state2.analyticsRequestStatus,
        sortField = _this$state2.sortField,
        sortDir = _this$state2.sortDir,
        hubsFailedToLoad = _this$state2.hubsFailedToLoad;
    var _this$props = this.props,
        shouldGetAnalytics = _this$props.shouldGetAnalytics,
        shouldWarnAboutObscured = _this$props.shouldWarnAboutObscured;
    var accountsLoading = accountsRequestStatus === _RequestStatusTypes.default.PENDING || accountsRequestStatus === _RequestStatusTypes.default.UNINITIALIZED;
    var analyticsLoading = shouldGetAnalytics && (analyticsRequestStatus === _RequestStatusTypes.default.PENDING || analyticsRequestStatus === _RequestStatusTypes.default.UNINITIALIZED);
    var loading = accountsLoading || analyticsLoading;

    if (accountsRequestStatus === _RequestStatusTypes.default.FAILED) {
      return _react.default.createElement(_UIErrorMessage.default, {
        type: "badRequest"
      }, _react.default.createElement("p", null, _I18n.default.text('error.requestFailed.description')));
    } else if (!loading && accounts.size === 0) {
      return _react.default.createElement(_UIErrorMessage.default, {
        illustration: "cone",
        type: "expired"
      }, _react.default.createElement("p", null, _I18n.default.text('error.noAccounts.description')));
    }

    return _react.default.createElement("div", null, shouldWarnAboutObscured && this.renderObscuredWarning(), hubsFailedToLoad && this.renderHubsFailedToLoadWarningBanner(), _react.default.createElement(_UITable.default, {
      className: "account-picker"
    }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement(_UISortTH.default, {
      className: "name",
      sort: sortField === 'accountName' ? sortDir : 'none',
      onSortChange: this.onSortChange('accountName')
    }, _I18n.default.text('hubPicker.name')), _react.default.createElement(_UISortTH.default, {
      className: "domain",
      sort: sortField === 'domain' ? sortDir : 'none',
      onSortChange: this.onSortChange('domain')
    }, _I18n.default.text('hubPicker.domain')), shouldGetAnalytics && _react.default.createElement(_UISortTH.default, {
      className: "sessions text-right",
      sort: sortField === 'currentPeriodSessions' ? sortDir : 'none',
      onSortChange: this.onAnalyticsSortChange('currentPeriodSessions'),
      align: "right"
    }, "Sessions"), shouldGetAnalytics && _react.default.createElement(_UISortTH.default, {
      className: "leads text-right",
      sort: sortField === 'currentPeriodLeads' ? sortDir : 'none',
      onSortChange: this.onAnalyticsSortChange('currentPeriodLeads'),
      align: "right"
    }, "Leads"), _react.default.createElement("th", null, _I18n.default.text('hubPicker.products')))), _react.default.createElement("tbody", null, loading ? this.renderLoader() : this.renderTableContents())));
  }
});
var _default = HubPicker;
exports.default = _default;
module.exports = exports.default;